import { gql } from '@apollo/client';

export const CREATE_DISCOUNT = gql`
    mutation CreateDiscount(
      $rate: Float!
      $name: String!
      $description: String
      ) {
        createDiscount(data: {
          rate: $rate
          name: $name
          description: $description
        }) {
          id
          rate
          name
          description
      }
    }
`;

export const UPDATE_DISCOUNT = gql`
  mutation UpdateDiscount(
    $id: String!
    $rate: Float
    $name: String
    $description: String
  ) {
    updateDiscount(
      data: {
        id: $id
        rate: $rate
        name: $name
        description: $description
    }) {
      id
      rate
      name
      description
    }
  }
`;

export const REMOVE_DISCOUNT = gql`
    mutation RemoveDiscount($id: String!) {
      removeDiscount(id: $id)
    }
`;
